import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { WarrantsDcaQueueParser } from "@/models/admin/warrantsDcaQueue/warrantsDcaQueue.parser"
import { IWarrantsDcaQueue } from "@/models/admin/warrantsDcaQueue/warrantsDcaQueue.types"
import {
  Financials_Warrants_Dca_Queue_Bool_Exp,
  Financials_Warrants_Dca_Queue_Order_By,
  GetWarrantsDcaQueueQuery,
} from "@/api/hasura/generated/graphql"

export interface WarrantsDcaQueueListResult {
  queue: IWarrantsDcaQueue[]
  totalCount: number
}

class WarrantsDcaQueueServiceClass {
  getQueue(
    search: string,
    page: number,
    pageSize: number,
    orderBy: Financials_Warrants_Dca_Queue_Order_By,
  ): QueryResult<WarrantsDcaQueueListResult> {
    const where: Financials_Warrants_Dca_Queue_Bool_Exp = {
      account_number: { _ilike: `%${search}%` },
    }

    return useQuery({
      ...HasuraQueries.warrants.dcaQueue(
        (page - 1) * pageSize,
        pageSize,
        where,
        orderBy,
      ),
      useRawResponse: true,
      placeholderData: { queue: [], totalCount: 0 },
      parserFn: (
        data: GetWarrantsDcaQueueQuery,
      ): WarrantsDcaQueueListResult => ({
        queue: data.financials_warrants_dca_queue.map(
          WarrantsDcaQueueParser.toDomain,
        ),
        totalCount:
          data.financials_warrants_dca_queue_aggregate.aggregate?.count ?? 0,
      }),
    })
  }
}

export const WarrantsDcaQueueService = new WarrantsDcaQueueServiceClass()
